import moment from 'moment';
import { Platform } from 'react-native';
import * as Constants from './Constants';
import * as SharedUtils from './SharedUtils';
import * as ConnectionManager from './ConnectionManager';
import { getAppCheckToken } from './appCheck';

const httpTimeout = (ms, promise) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error('timeout'));
    }, ms);
    promise.then(resolve, reject);
  });


export const httpRequest = async url => {
  /* Send request */
  const TIMEOUT = 20000;

  const response = await httpTimeout(
    TIMEOUT,
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).catch(error => {
      console.error(error);
      return Constants.networkError_code;
    })
  ).catch(error => {
    return Constants.networkError_code;
  });
  ConnectionManager.setServerDown(response === Constants.networkError_code);
  if (response === Constants.networkError_code) {
    return response;
  }
  const json = await response.json();
  return json;
}


export const ping = async (url, timeout) => {
  const response = await httpTimeout(
    timeout,
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: 'action='
    }).then((response) => {
      if (response.status !== 200) {
        throw new Error('HTTP response status not code 200 as expected.');
      }
    }).catch(error => {
      console.error(error);
      return Constants.networkError_code;
    })
  ).catch(error => {
    console.log(error);
    return Constants.networkError_code;
  });
  ConnectionManager.setServerDown(response === Constants.networkError_code);
  return response;
}

export const pickHttpRequest = async params => {
  /* Send request */
  params = params.replace(/١/g, "1")
    .replace(/٢/g, "2")
    .replace(/٣/g, "3")
    .replace(/٤/g, "4")
    .replace(/٥/g, "5")
    .replace(/٦/g, "6")
    .replace(/٧/g, "7")
    .replace(/٨/g, "8")
    .replace(/٩/g, "9")
    .replace(/٠/g, "0");

  const deviceID = await SharedUtils.getDeviceID();
  const token = await SharedUtils.getFromAS(Constants.TOKEN);
  const language = await SharedUtils.language();
  let appCheckToken = null;
  try {
    appCheckToken = await getAppCheckToken();
  } catch (error) {
    console.error('Firebase App Check token unavailable:', error);
    alert('Firebase App Check token unavailable');
    return { ERROR: 'Firebase App Check validation failed' };
  }
  const TIMEOUT = 20000;
  const MAX_RETRIES = 3;

  const url = Constants.pickServerUrl + params
    + "&token=" + token
    + "&appversion=" + Constants.VERSION
    + "&deviceid=" + deviceID
    + "&applang=" + language;
  // Retry loop
  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      const response = await httpTimeout(
        TIMEOUT,
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...(appCheckToken ? { 'X-Firebase-AppCheck': appCheckToken } : {}),
          },
          body: new Blob([params], { type: 'text/plain' })
        }).then(async response => {
          // Check for 401 Unauthorized error
          if (response.status === 401) {
            console.warn('401 Unauthorized - redirecting to home');
            // Redirect to home
            if (typeof window !== 'undefined' && window.location) {
              window.location.href = './home';
            }
            return { "ERROR": "Unauthorized access - redirected to home" };
          }

          // Try to parse JSON to catch JSON parse errors early
          if (response.ok) {
            try {
              const text = await response.text();
              if (text.trim() === '') {
                throw new Error('Empty response body');
              }

              // Try to parse JSON
              const jsonData = JSON.parse(text);

              // Return a response-like object with the parsed data
              return {
                ok: true,
                status: response.status,
                json: () => Promise.resolve(jsonData),
                text: () => Promise.resolve(text)
              };
            } catch (jsonError) {
              console.error(`JSON Parse error on attempt ${attempt}:`, jsonError);
              throw new Error(`JSON Parse error: ${jsonError.message}`);
            }
          }

          return response;
        }).catch(error => {
          console.error(`Fetch error on attempt ${attempt}:`, error);
          throw error; // Re-throw to trigger retry
        })
      );

      // If we got here, the request was successful
      ConnectionManager.setServerDown(false);
      return response;
    } catch (error) {
      console.log(`Attempt ${attempt} failed:`, error);

      // If this was the last attempt, return error
      if (attempt === MAX_RETRIES) {
        console.error(`All ${MAX_RETRIES} attempts failed`);
        ConnectionManager.setServerDown(true);
        return { "ERROR": "Unable to connect " + Constants.networkError_code };
      }

      // Otherwise, wait a bit before retrying (exponential backoff)
      await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
    }
  }
};



export const checkIfUserExists = async (username, email, mobile) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_USERS}`;
  params += `&email=${email}`;
  params += `&username=${username}`;
  params += `&mobile=${mobile}`;
  /* Send request */
  const response = await pickHttpRequest(params);
  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }
  return null;
};

export const loadCustomers = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_USERS}`;
  /* Send request */
  const response = await pickHttpRequest(params);
  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }
  return null;
};

export const loadMenuItems = async (category = '') => {
  /* Request params */
  const language = await SharedUtils.language();
  let user = await SharedUtils.getUserObject();
  if (user.USERNAME == '') user.USERNAME = 'guest';
  let params = '';
  params += `action=${Constants.GET_ITEMS}`;
  params += `&user=${user.USERNAME}`;
  params += `&lang=${language}`;
  params += `&category=${category}`;
  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getRegisterationOTP = async (mobile) => {
  let params = '';
  params += `action=${Constants.GET_OTP}`;
  params += `&mobile=${mobile}`;
  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const registerUser = async (user, isUpdate) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.REGISTER}`;
  params += `&email=${user.EMAIL}`;
  params += `&username=${user.USERNAME}`;
  params += `&password=${user.PASSWORD}`;
  params += `&firstName=${user.FIRSTNAME}`;
  params += `&lastName=${user.LASTNAME}`;
  params += `&birthdate=${user.BIRTHDATE}`;
  params += `&gender=${user.GENDER}`;
  params += `&mobile=${user.MOBILE}`;
  params += `&married=${user.MARITAL_STATUS}`;
  params += `&childcount=${user.NUM_OF_CHILDREN}`;
  params += `&location=${user.LOCATION.latitude},${user.LOCATION.longitude}`;
  params += `&address=${user.ADDRESS}`;
  params += `&city=${user.CITY}`;
  params += `&savetype=${isUpdate ? 'modify' : 'register'}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const checkCredentials = async (username, isFacebook, id, first_name, last_name, email, mobile, password) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.USER_INFO}`;
  params += `&username=${username}`;
  params += `&isFacebook=${isFacebook}`;
  params += `&id=${id}`;
  params += `&first_name=${first_name}`;
  params += `&last_name=${last_name}`;
  params += `&email=${email}`;
  params += `&mobile=${mobile}`;
  params += `&password=${password}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const sendRecoveryEmail = async username => {
  /* Request params */
  let params = '';
  params += `action=${Constants.FORGOT}`;
  params += `&user=${username}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getPaymentInfo = async items => {
  /* Request params */
  let params = '';
  params += `action=${Constants.CALC_ORDER}`;
  params += `&user=${user.USERNAME}`;
  params += `&table=${itemsStr}`;
  params += `&BONUSOK=1`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getActiveOrders = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_ACTIVE_ORDERS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getOrders = async (fromDate, toDate, id, isexcel = false) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_ORDERS}`;
  if (id === '') {
    params += `&FROMDATE=${fromDate}`;
    params += `&TODATE=${toDate}`;
  }
  if (id !== '') {
    params += `&FROMDATE=${fromDate}`;
    params += `&TODATE=${toDate}`;
    params += `&ID=${id}`;
    if (isexcel) params += `&excel`;
  }

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getOrdersTimelineDetails = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_ORDERS_TIMELINE_DETAILS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getSOA = async (fromDate, toDate) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_SOA}`;
  params += `&fromDate=${fromDate}`;
  params += `&toDate=${toDate}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};


export const getSaveUserNotificationSettings =
  async (status, relatedNotif, stockNotif, promoNotif, accountNotif, criticalAlert, whatsappNotif, appNotif) => {
    /* Request params */
    let params = '';
    params += `action=${Constants.GET_SAVE_USER_NOTIFICATIONS_SETTINGS}`;
    if (status !== '') {
      params += `&status=${status}`;
    }
    if (relatedNotif !== '') {
      params += `&relatedNotif=${relatedNotif}`;
    };
    if (stockNotif !== '') {
      params += `&stockNotif=${stockNotif}`;
    }
    if (promoNotif !== '') {
      params += `&promoNotif=${promoNotif}`;
    }
    if (accountNotif !== '') {
      params += `&accountNotif=${accountNotif}`;
    }
    if (criticalAlert !== '') {
      params += `&criticalAlert=${criticalAlert}`;
    }
    if (whatsappNotif !== '') {
      params += `&whatsappNotif=${whatsappNotif}`;
    }
    if (appNotif !== '') {
      params += `&appNotif=${appNotif}`;
    }

    /* Send request */
    const response = await pickHttpRequest(params);

    /* Check response */
    if (response === Constants.networkError_code) {
      return null;
    }
    if (response.ok) {
      return await response.json();
    }

    return null;
  };

export const getActivateAccountRequest = async (accountNo, attachment) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_ACTIVATE_ACCOUNT_REQUEST}`;
  params += `&USER=${accountNo}`;
  params += `&FILENAME=${attachment}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getOutOfStockMsg = async lang => {
  /* Request params */
  let params = '';
  params += `action=${Constants.OUT_OF_STOCK_MESSAGE}`;
  params += `&lang=${lang}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getMinOrd = async lang => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_MIN_ORD}`;
  params += `&lang=${lang}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getAppStatus = async lang => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_APP_STATUS}`;
  params += `&lang=${lang}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};


export const getFindUs = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_FIND_US}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getNewOrderMessage = async lang => {
  /* Request params */
  let params = '';
  params += `action=${Constants.NEW_ORDER_MESSAGE}`;
  params += `&lang=${lang}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};


export const placeOrder = async (items, simulate = false, notes = '') => {
  let params = '';
  params += `action=${Constants.PLACE_ORDER}`;
  if (items !== '') {
    params += `&items=${encodeURIComponent(JSON.stringify(items))}`;
  }
  if (simulate) {
    params += `&simulate=1`;
  }
  if (notes !== '') {
    params += `&notes=${encodeURIComponent(notes.replace(/\n/g, ' ').replace(/'/g, ' ').replace(/;/g, ' '))}`;
  }
  const response = await pickHttpRequest(params);

  // Handle response as JSON
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response && typeof response.json === 'function') {
    return await response.json();
  }
  return response;
};

export const calcOrderPrice = async (items, promoCode = '', location) => {
  // Prepare items string if needed, or assume items is already JSON/stringified
  let params = '';
  params += `action=${Constants.CALC_ORDER}`;
  if (items !== '') {
    params += `&items=${encodeURIComponent(JSON.stringify(items))}`;
  }
  // if (promoCode) {
  //   params += `&PROMOCODE=${encodeURIComponent(promoCode)}`;
  // }
  // if (location) {
  //   params += `&LOCATION=${encodeURIComponent(location)}`;
  // }

  // Send request
  const response = await pickHttpRequest(params);

  // Handle response as JSON
  if (response === Constants.networkError_code) {
    return null;
  }
  // If pickHttpRequest returns a Response object, parse JSON
  if (response && typeof response.json === 'function') {
    return await response.json();
  }
  // If pickHttpRequest already returns parsed JSON, just return it
  return response;
};

export const confirmOrder = async (items, date, time, address, phoneNumber, user, Disc, Tax, Net, orderNote,
  userLocation, orderId, lang, payment_method, payment_reqid = '', addressNote, isGift, recipient, recipientMobile, promoCode, strOnly = false, credit) => {
  // Check if to send a copy of invoice by email
  const invByEmail = (await SharedUtils.getFromAS(Constants.invByEmail)) !== Constants.FALSE_STR;

  // prepare items str
  let itemsStr = '';
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.SubItems !== undefined && item.SubItems.length > 0) {
      item.SubItems.map(subItem => {
        itemsStr += `${subItem.ID};${subItem.Price};${subItem.Qty};${subItem.Bonus};${subItem.Disc};${subItem.Tax};${subItem.Note};${item.ID};${item.Qty}@@`;
      });
    } else {
      itemsStr += `${item.ID};${item.Price};${item.Qty};${item.Bonus};${item.Disc};${item.Tax};${item.Note};@@`;
    }
  }

  const delimter1 = strOnly ? "&&" : "&"
  const delimter2 = strOnly ? "==" : "="
  /* Request params */
  let params = '';
  params += `action${delimter2}${Constants.CONFIRM_ORDER}`;
  params += `${delimter1}date${delimter2}${moment(date).format('YYYY-MM-DD')}`;
  params += `${delimter1}time${delimter2}${time}`;
  params += `${delimter1}address${delimter2}${address}`;
  params += `${delimter1}phone${delimter2}${phoneNumber}`;
  params += `${delimter1}data${delimter2}${itemsStr}`;
  params += `${delimter1}customer${delimter2}${user.USERNAME}`;
  params += `${delimter1}discount${delimter2}${Disc}`;
  params += `${delimter1}tax${delimter2}${Tax}`;
  params += `${delimter1}total${delimter2}${Net}`;
  params += `${delimter1}note${delimter2}${orderNote}`;
  params += `${delimter1}addressNote${delimter2}${addressNote}`;
  params += `${delimter1}location${delimter2}${userLocation.latitude},${userLocation.longitude}`;
  params += `${delimter1}invByEmail${delimter2}${invByEmail ? '1' : '0'}`;
  params += `${delimter1}orderID${delimter2}${orderId === undefined ? '' : orderId}`;
  params += `${delimter1}MINORDOK1${delimter2}`;
  params += `${delimter1}LANG${delimter2}${lang}`;
  params += `${delimter1}VERSION${delimter2}${Platform.OS} ${Constants.VERSION}`;
  params += `${delimter1}payment_method${delimter2}${payment_method}`;
  params += `${delimter1}payment_reqid${delimter2}${payment_reqid}`;
  params += `${delimter1}isGift${delimter2}${isGift}`;
  params += `${delimter1}recipient${delimter2}${recipient}`;
  params += `${delimter1}recipientMobile${delimter2}${recipientMobile}`;
  params += `${delimter1}promoCode${delimter2}${promoCode}`;
  params += `${delimter1}credit${delimter2}${credit}`;

  if (strOnly) {
    return params;
  }
  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const loadMyOrders = async (username, isPayment) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.USERORDERS}`;
  params += `&customer=${username}`;
  params += `&isPayment=${isPayment}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const cancelOrder = async (orderId, invoiceId) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.CANCEL_ORDER}`;
  params += `&ID=${orderId}`;
  params += `&INV_ID=${invoiceId}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const canModifyOrder = async orderId => {
  /* Request params */
  let params = '';
  params += `action=${Constants.CAN_MODIFY}`;
  params += `&ID=${orderId}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getDlvTimes = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.DLVTIMES}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getNotifications = async user => {
  if (user === undefined) {
    user = await SharedUtils.getUserObject();
  }

  /* Request params */
  let params = '';
  params += `action=${Constants.NOTIFICATIONS}`;
  params += `&user=${user.USERNAME}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};


export const getFilters = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_FILTERS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getProducts = async (id, brand, category, pharmaCategory) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_PRODUCTS}`;
  if (id !== '') {
    params += `&ID=${id}`;
  }
  if (brand !== '') {
    params += `&BRAND=${brand}`;
  }
  if (category !== '') {
    params += `&CATEG=${category}`;
  }
  if (pharmaCategory !== '') {
    params += `&PHARMA=${pharmaCategory}`;
  }

  /* Send request */
  const response = await pickHttpRequest(params);


  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    const json = await response.json();
    return json;
  }

  return null;
};


export const getPharmaceuticalsBrands = async (id) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_PHARMAC_BRANDS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getBrands = async (id) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_BRANDS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getConumerBrands = async (id) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_CONSUMER_BRANDS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};


export const getAdvImages = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_ADV}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }
  return null;
};

export const sendEmail = async (emailName, email, category, msg) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.SEND_EMAIL}`;
  params += `&emailname=${encodeURIComponent(emailName)}`;
  params += `&email=${encodeURIComponent(email)}`;
  params += `&category=${encodeURIComponent(category)}`;
  params += `&msg=${encodeURIComponent(msg)}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }
  return null;
};

export const getJobOpening = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_JOB_OPENINGS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getInvoices = async (fromDate, toDate, invNo, invID) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_INVOICES}`;
  if (invNo === '') {
    params += `&fromDate=${fromDate}`;
    params += `&toDate=${toDate}`;
  } else {
    params += `&ID=${invNo}`;
    params += `&invID=${invID == undefined ? '' : invID}`;
  }


  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getUserInfo = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_USER_INFO}`;
  // params += `&user=${user.USERNAME}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return false;
  }
  if (response.ok) {
    return await response.json();
  }

  return false;
};

export const updateUserImage = async (filename) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.UPDATE_USER_IMAGE}`;
  params += `&filename=${filename}`;
  // params += `&user=${user.USERNAME}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return false;
  }
  if (response.ok) {
    return await response.json();
  }

  return false;
};

export const checkToken = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.CHECK_TOKEN}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return false;
  }
  if (response.ok) {
    return await response.json();
  }

  return false;
};

export const getReturns = async (fromDate, toDate, ID, invID) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_RETURNS}`;
  if (ID === '') {
    params += `&fromDate=${fromDate}`;
    params += `&toDate=${toDate}`;
  } else {
    params += `&ID=${ID}`;
    params += `&invID=${invID == undefined ? '' : invID}`;
  }

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const checkOtpResponse = async (otp, mobile) => {

};

export const getCustomerPhoneMask = async (customerCode) => {
  let params = '';
  params += `action=${Constants.GET_CUST_PHONE_MASK}`;
  params += `&user=${customerCode}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const login = async (accountNo, phoneNo, otp) => {
  let params = '';
  params += `action=${Constants.LOGIN}`;
  params += `&user=${accountNo}`;
  params += `&phone=${phoneNo}`;
  params += `&otp=${otp}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const checkCustomerPhone = async (accountNo, phoneNo) => {
  let params = '';
  params += `action=${Constants.CHECK_CUST_PHONE}`;
  params += `&user=${accountNo}`;
  params += `&phone=${phoneNo}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getHistory = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_HISTORY}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getCommonFAQs = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_COMMON_FAQS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getOffers = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_OFFERS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getCategories = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_CATEGORIES}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getBestSellers = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_BEST_SELLERS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getFeaturedItems = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_FEATURED_ITEMS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getFeaturedBestSellers = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GET_FEATURED_AND_BEST_SELLERS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const viewOrder = async orderId => {
  /* Request params */
  let params = '';
  params += `action=${Constants.VIEWORDER}`;
  params += `&ID=${orderId}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const sendPushNotificationsToken = async user => {
  const token = await SharedUtils.getPushNotificationsToken();
  if (user === undefined) {
    user = await SharedUtils.getUserObject();
  }

  if (token === '') {
    return;
  }

  /* Request params */
  let params = '';
  params += `action=${Constants.REG_DEV}`;
  params += `&user=${user.USERNAME}`;
  params += `&device=${encodeURIComponent(token)}`;
  params += `&info=${Platform.OS} ${Constants.VERSION}`;

  /* Send request */
  await pickHttpRequest(params);
};

export const pickUploadHttpRequest = async (file, name) => {
  const fileName = String(file?.name || name || '');
  const extension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
  const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
  const fileType = String(file?.type || '').toLowerCase();
  const fileSize = Number(file?.size || 0);
  if (!allowedExtensions.includes(extension) || (fileType && !allowedTypes.includes(fileType))) {
    return { ok: false, ERROR: 'Unsupported file type' };
  }
  if (fileSize > 10 * 1024 * 1024) {
    return { ok: false, ERROR: 'File is too large' };
  }

  const TIMEOUT = 45000;
  const safeName = String(name || fileName)
    .replace(/\.\./g, '')
    .replace(/[^a-zA-Z0-9._\\/-]/g, '_');
  const url = Constants.serverBaseUrl + '/pick/faces/redirect/jdsco?action=upload&fileupload=y&fname=' + encodeURIComponent(safeName)
  const body = new FormData();
  body.append('file', file);
  const response = await httpTimeout(
    TIMEOUT,
    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body
    }).catch(error => {
      console.error(error);
      return Constants.networkError_code;
    })
  ).catch(error => {
    console.log(error);
    return Constants.networkError_code;
  });
  return response;
};

export const postOrderReview = async (orderId, rateService, rateProduct, review) => {

  /* Request params */
  let params = '';
  params += `action=${Constants.RATE}`;
  params += `&id=${orderId}`;
  params += `&rateService=${rateService}`;
  params += `&rateProduct=${rateProduct}`;
  params += `&message=${review.replace(/\n/g, '@@')}`;


  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const toggleRecNewsInfo = async (username, value) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.RCVNEWS}`;
  params += `&user=${username}`;
  params += `&val=${value ? '1' : '0'}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getUserLocation = async (user) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GETLOCATION}`;
  params += `&user=${user}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const getUserLocations = async (user, lang) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.GETLOCATIONHIST}`;
  params += `&user=${user}`;
  params += `&lang=${lang}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const loadOffers = async () => {
  /* Request params */
  let params = '';
  params += `action=${Constants.OFFERS}`;

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};


export const requestInvoice = async (vehicle, date) => {
  /* Request params */
  let params = '';
  params += `action=${Constants.INVOICE}`;
  params += `&customer=${vehicle}`;
  params += `&date=${date}`;
  //params += `&date=2020-01-16`

  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return null;
  }
  if (response.ok) {
    return await response.json();
  }

  return null;
};

export const postInvoice = async (vehicle, Invoice, Paid, DlvDate, note, method, status) => {
  /* Request params */
  let params = '';
  note = note.replace(/[^a-zA-Z0-9]/g, "~");
  params += `action=${Constants.POSTINVOICE}`;
  params += `&id=${Invoice}`;
  params += `&paid=${Paid}`;
  params += `&driver=${vehicle}`;
  params += `&note=${note}`;
  params += `&method=${method}`;
  params += `&status=${status}`;
  params += `&date=${DlvDate}`;
  //params += `&date=2020-01-16`
  /* Send request */
  const response = await pickHttpRequest(params);

  /* Check response */
  if (response === Constants.networkError_code) {
    return "Update failed";
  }
  if (response.ok) {
    return "Update successful";
  }

  return null;
};
